import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { MenuItem, SxProps, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { CollectionOpenSearch } from '@europrocurement/l2d-domain';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { OrderAction } from '../providers/OrderActionContext';

type useCollectionActionMenuItemsProps = {
    collection: CollectionOpenSearch;
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
    triggerAction: (action: OrderAction, selectedCollection: Array<CollectionOpenSearch>) => void;
    refreshCollection: () => void;
    getOrderDuplicateRoute?: (id: number) => string;
};
const useCollectionActionMenuItems = ({
    collection,
    triggerAction,
    setAnchorEl,
}: useCollectionActionMenuItemsProps) => {
    const { enqueueSnackbar } = useSnackbar();

    const handleOpenModalCollectionAction = (action: OrderAction) => {
        triggerAction(action, [collection]);
        setAnchorEl(null);
    };

    const handleUnExistingAlert = () => {
        enqueueSnackbar('Non implémenté', {
            variant: 'error',
        });
    };

    type renderMenuItemProps = {
        key: string;
        action: () => void;
        iconName?: IconName;
        label?: string;
        textSx?: SxProps;
        iconSx?: SxProps;
    };
    const renderMenuItem = ({
        key,
        action,
        iconName = 'exclamation-circle',
        label = 'menu item',
        textSx,
        iconSx,
    }: renderMenuItemProps) => (
        <MenuItem
            key={key}
            onClick={action}
            sx={{ gap: '4px' }}
        >
            <FaOptionIcon
                icon={['fasl', iconName]}
                color="text.gris70"
                sx={iconSx}
            />
            <Typography sx={{ color: 'text.primary', ...textSx }}>{label}</Typography>
        </MenuItem>
    );

    const editCollectionMenuItem = renderMenuItem({
        key: 'updateCollectionActionItem',
        action: handleUnExistingAlert,
        iconName: 'file-pen',
        label: 'Modifier la commande',
    });

    const urgentCollectionMenuItem = renderMenuItem({
        key: 'urgentActionItem',
        action: () => handleOpenModalCollectionAction('urgent'),
        iconName: 'exclamation-circle',
        label: 'Marquer comme urgent',
    });

    const collectionActionMenuItemsFront: React.JSX.Element[] = [];

    const collectionActionMenuItemsBack: React.JSX.Element[] = [
        editCollectionMenuItem,
        urgentCollectionMenuItem,
    ];

    const collectionDetatilQuickActionBack: React.JSX.Element[] = [
        editCollectionMenuItem,
        urgentCollectionMenuItem,
    ];

    const collectionDetatilQuickActionFront: React.JSX.Element[] = [];

    const getCollectionDetailActionBySource = (source: 'FRONT' | 'BACK'): React.JSX.Element[] => {
        if (source === 'BACK') {
            return collectionDetatilQuickActionBack;
        }
        return collectionDetatilQuickActionFront;
    };

    return {
        collectionActionMenuItemsFront,
        collectionActionMenuItemsBack,
        collectionDetatilQuickActionBack,
        collectionDetatilQuickActionFront,
        getCollectionDetailActionBySource,
    };
};

export default useCollectionActionMenuItems;
